import { useEffect } from 'react';

const SITE_URL = 'https://svabogadas.cl';

/** Crea o actualiza un <meta> por atributo (name o property). */
function setMetaTag(attr: 'name' | 'property', key: string, content: string) {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

/** Crea o actualiza el <link rel="canonical">. */
function setCanonical(url: string) {
  let el = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', 'canonical');
    document.head.appendChild(el);
  }
  el.setAttribute('href', url);
}

/**
 * Ajusta título, meta description, canonical y Open Graph según la página actual
 * de la SPA. Googlebot renderiza el JS y toma estos valores por ruta, evitando
 * que todas las páginas compartan el título/descripción de la home.
 *
 * @param title       Título de la pestaña / resultado de búsqueda.
 * @param description Meta description (~150–160 caracteres).
 * @param path        Ruta canónica de la página (ej. "/areas/derecho-laboral").
 */
export function usePageMeta(title: string, description: string, path = '/') {
  useEffect(() => {
    const url = SITE_URL + (path === '/' ? '/' : path);
    document.title = title;
    setMetaTag('name', 'description', description);
    setCanonical(url);
    setMetaTag('property', 'og:title', title);
    setMetaTag('property', 'og:description', description);
    setMetaTag('property', 'og:url', url);
    setMetaTag('name', 'twitter:title', title);
    setMetaTag('name', 'twitter:description', description);
  }, [title, description, path]);
}
